import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import GridItem from "components/Grid/GridItem.js";
import IconButton from '@material-ui/core/IconButton';
import Visibility from "@material-ui/icons/Visibility";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import GridContainer from "components/Grid/GridContainer.js";
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from "components/CustomButtons/Button.js";
import DateFnsUtils from '@date-io/date-fns';
import Circular from '../Circular/Circular';
import Table from 'components/Table/Table';
import { getAllOrders } from '../../services/orders/orders';
import InfoOrder from 'components/Orders/InfoOrder';
import ExportCsv from "exportCsv.js";


const useStyles = theme => ({
    root: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(2),
            width: 200,
            marginLeft: "1px"
        }
    },
    rootCircular: {
        flexGrow: 1,
        backgroundColor: "#f1f1f2"
    },
    green: {
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    },
    buttonAlign: {
        float: 'right'
    }
  });

class Search extends Component {

    state = {
        statuses: [ 
            {
              value: 'reserved',
              label: 'Reservado',
            },
            ,
            {
              value: 'collected',
              label: 'Coletado',
            },
            {
              value: 'allocated',
              label: 'Alocado',
            },
            {
              value: 'canceled',
              label: 'Cancelado',
            },
            {
               value: null,
               label: '-'
            },
        ],
        status: null,
        code: null, 
        dateFrom: null,
        dateTo: null,
        circular: false,
        orders: [],
        order: {},
        orderId: null,
        showInfo: false
    }

    handleChange = (event) => {
        let e = (event.target.id) ? event.target.id : event.target.name;

        switch (e) {
            case 'codeOrder':
                this.setState({ code: event.target.value })
                break;
            case 'status':
                this.setState({ status:event.target.value })
                break;
        }
    }

    handleChangeDateFrom = (dateFrom) => {
        this.setState({ dateFrom });
    }

    handleChangeDateTo = (dateTo) => {
        this.setState({ dateTo });
    }

    getOrderById = (orderId, order) => {
        this.setState({ orderId, order, showInfo: true });
    }

    handleSearch = () => {
        let { code, status, dateFrom, dateTo } = this.state;

        this.setState({ circular: true });

        const startOfDay = new Date(dateFrom);
        startOfDay.setUTCHours(0, 0, 0, 0);

        const endOfDay = new Date(dateTo);
        endOfDay.setUTCHours(23, 59, 59, 999);

        let filter = '';
        let orders = [];
        filter += dateTo ? `&filter[createdAt][$gte]=${startOfDay.toISOString()}` : '';
        filter += dateFrom ? `&filter[createdAt][$lte]=${endOfDay.toISOString()}` : '';
        filter += status ? `&filter[status]=${status}` : '';
        filter += code ? `&filter[codOrder]=${code}` : '';

        console.log("FILTER:", filter);

        getAllOrders(this.props.lockerId, filter, (data) => {

            data.map(d => {
                let { id, slotName, status, codOrder, collectToken } = d;

                orders.push([id.substring(5, 10).toUpperCase(), (codOrder) ? codOrder : '-',
                            (slotName) ? slotName : '-', (collectToken) ? collectToken : '-',
                            (status) ? status : '-', 
                            <IconButton aria-label="view" onClick={() => this.getOrderById(id, d)}>
                                <Visibility  />
                            </IconButton>]);
            });   
        });

        setTimeout(() => {
            this.setState({circular: false, orders});
        }, 1500);
    }

    setDialog = (showInfo) => {
        this.setState({ showInfo });
    }

    handleExport = () => {

        let dataCSV = [];
        
        this.state.orders.map(order => {
            dataCSV.push({"Id": order[0], "Cód. Encomenda": order[1], "Porta": order[2], 
                          "Token": order[3], "Status": order[4]});

        });
        
        ExportCsv(dataCSV);
    }

    render() {
        const { classes } = this.props;
        let { status, code, dateFrom, dateTo, circular, orders, showInfo, orderId, order } = this.state;

        return(
            <div className={classes.green}>
                <form className={classes.root} noValidate autoComplete="off">
                    <h5>Busca de encomendas</h5>
                    <GridContainer>
                        <GridItem xs={12} sm={6} md={3}>
                            <FormControl className={classes.green}>
                                <InputLabel htmlFor="codeOrder">Cód. Encomenda</InputLabel>
                                <Input
                                value={code}
                                onChange={this.handleChange}
                                id="codeOrder"
                                />
                            </FormControl>
                        </GridItem>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <GridItem xs={12} sm={6} md={3}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="from"
                                    label="Data Maior que :"
                                    value={dateFrom}
                                    onChange={this.handleChangeDateFrom}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={3}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="to"
                                    label="Data Menor que:"
                                    value={dateTo}
                                    onChange={this.handleChangeDateTo}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </GridItem>
                        </MuiPickersUtilsProvider>
                        <GridItem xs={12} sm={6} md={3}>
                            <TextField className={classes.green}
                                select
                                label="Status encomenda"
                                name="status"
                                value={status}
                                onChange={this.handleChange}
                                >
                                    {this.state.statuses.map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </GridItem>
                    </GridContainer>
                    <Button onClick={this.handleSearch} color="primary" autoFocus>
                        Pesquisar
                    </Button>
                </form>
                {(circular) ? <div className={classes.rootCircular}>
                                <Circular />
                              </div> : (orders.length ===0) ? null : <div>
                                        <Button className={classes.buttonAlign} onClick={this.handleExport} color="default" autoFocus>
                                            <FileCopyIcon /> Exportar CSV
                                        </Button>
                                        <Table
                                        tableHeaderColor="primary"
                                        tableHead={["Id", "Cód. Encomenda", "Porta", "Token", "Status", "Ação"]}
                                        tableData={orders}
                                        />
                                  </div> }
                {(showInfo) ? <InfoOrder
                    open={showInfo}
                    lockerId={this.props.lockerId}
                    orderId={orderId}
                    order={order}
                    onChange={this.setDialog}
                /> : null}
            </div>
        );
    }
}

export default withStyles(useStyles) (Search);